import { literal, object, string } from "superstruct";

import type { PathParamsBase } from "../endpoint/Endpoint.js";
import Endpoint from "../endpoint/Endpoint.js";
import EndpointRouter from "../endpoint/EndpointRouter.js";
import { ProjetSchema } from "../models/Projet.js";
import { type User } from "../models/User.js";

export default function buildProjectRouter(base: EndpointRouter<PathParamsBase, { user: User }>) {
    const router = base.addRouter(
        new EndpointRouter().setContextParser(object({ projet: ProjetSchema })),
    );

    const endpoints = {
        updateProjetEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("PUT")
                .setPath("/projets/:projet", object({ projet: string() }))
                .setResultParser(literal(null))
                .setBodySchema(object({ label: string() })),
        ),
    };

    return { router, endpoints };
}
